import { Toaster as Sonner } from "sonner";
import React from "react";

export function Toaster(props) {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "!bg-[hsl(var(--bg-elev-1))] !border !border-[hsl(var(--border))] !text-[hsl(var(--fg))] !rounded-lg",
          description: "!text-[hsl(var(--muted))]",
          success: "!text-[hsl(var(--success))]",
          error: "!text-[hsl(var(--danger))]",
        },
      }}
      {...props}
    />
  );
}
